export enum MealSlot {
  Breakfast = 'Breakfast',
  Lunch = 'Lunch',
  Snack = 'Snack',
  Dinner = 'Dinner',
}
